import React, { useContext, useState } from "react";
import { Popover } from "antd";
import { truncate } from "../../library/text";
import SmallModal from "../../components/SmallModal/SmallModal";
import GoodsTable from "./components/GoodsTable";
import PopupNotes from "../../components/PopupNotes/PopupNotes";
import InfoContext, { AppContext } from "../../context";
import SelectQuantity from "../../components/SelectQuantity/SelectQuantity";
import { GOODS } from "./goodsConstants";
import AddToCart from "../../components/AddToCart/AddToCart";
import { addGoodsToCart } from "./addGoodsToCart";
import SelectVillage from "./components/SelectVillage";
import { VILLAGES_OBJ } from "../../constants/constants";

function GoodsCardContent({
  product,
  context,
  setAddedToCart,
  setIsAddedToCartVisible,
  clientRequest,
}) {
  const [isPriceModalVisible, setIsPriceModalVisible] = useState(false);
  const [quantity, setQuantity] = useState(1);
  const [deliveryVillage, setDeliveryVillage] = useState(null);
  let info = useContext(AppContext);

  const selectComponent = () => {
    switch (context) {
      case undefined:
        return (
          <>
            <div className="card-body">
              <div className="short-description">
                {product.gen_description
                  ? truncate(product.gen_description["pt"], 100, true)
                  : ""}
              </div>
            </div>
          </>
        );
      case "reservation-info":
        return (
          <>
            <SelectVillage setVillage={setDeliveryVillage} />
            <SelectQuantity
              quantity={quantity}
              setQuantityFn={setQuantity}
              options={GOODS.QUANTITIES}
            />
            <div>
              {info.t("total_value")}: {quantity * product.gen_price} €
            </div>
            <AddToCart
              setIsAddedToCartVisible={setIsAddedToCartVisible}
              handleAddToCart={() =>
                addGoodsToCart(
                  product,
                  info,
                  quantity,
                  deliveryVillage,
                  clientRequest,
                  setAddedToCart
                )
              }
            />
          </>
        );

      case "cart":
      case "reservation":
      case "ticket":
      case "payment":
        return (
          <>
            {/* <GoodsTable product={product} /> */}
            {product.goo_delivery_village && (
              <div>
                {info.t("selectedVillage")}:{" "}
                {VILLAGES_OBJ[product.goo_delivery_village]}
              </div>
            )}
            {product.request && <PopupNotes notes={product.request} />}
          </>
        );
      default:
        return <div></div>;
    }
  };

  return (
    <>
      {product.gen_price !== null &&
        product.gen_price !== 0 &&
        context !== "ticket" &&
        context !== "reservation-info" &&
        context !== "payment" &&
        !(
          product.status === "not-available" || product.status === "not-defined"
        ) && (
          <div className="ahp-price">
            <div className="ahp-price-value">
              {product.gen_price || product.total_price} €
            </div>
          </div>
        )}
      {selectComponent()}

      {isPriceModalVisible && (
        <SmallModal
          text="Preço total."
          isPriceModalVisible={isPriceModalVisible}
          setIsPriceModalVisible={setIsPriceModalVisible}
        />
      )}
    </>
  );
}

export default GoodsCardContent;
